import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-04302652"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("新增好物")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 搜索")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 重置")
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = /*#__PURE__*/_createTextVNode("不显示")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("显示")
const _hoisted_7 = { key: 5 }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("状态")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_11 = { key: 0 }
const _hoisted_12 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_14 = ["src"]
const _hoisted_15 = { style: {"margin-left":"60px"} }
const _hoisted_16 = /*#__PURE__*/_createTextVNode("店铺名称：")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("店铺id：")
const _hoisted_18 = ["src"]
const _hoisted_19 = { style: {"margin-left":"60px","position":"absolute"} }
const _hoisted_20 = {
  class: "name",
  style: {"margin-top":"-30px"}
}
const _hoisted_21 = /*#__PURE__*/_createTextVNode("商品名称：")
const _hoisted_22 = { style: {"margin-top":"15px"} }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { key: 2 }
const _hoisted_25 = { key: 3 }
const _hoisted_26 = /*#__PURE__*/_createTextVNode("价格区间：")
const _hoisted_27 = /*#__PURE__*/_createTextVNode("实际销量：")
const _hoisted_28 = /*#__PURE__*/_createTextVNode("总库存：")
const _hoisted_29 = { key: 4 }
const _hoisted_30 = /*#__PURE__*/_createTextVNode("发布时间：")
const _hoisted_31 = /*#__PURE__*/_createTextVNode("修改区间：")
const _hoisted_32 = { key: 5 }
const _hoisted_33 = /*#__PURE__*/_createTextVNode("审核状态：")
const _hoisted_34 = /*#__PURE__*/_createTextVNode("审核备注：")
const _hoisted_35 = { key: 6 }
const _hoisted_36 = /*#__PURE__*/_createTextVNode("查看")
const _hoisted_37 = /*#__PURE__*/_createTextVNode("设置")
const _hoisted_38 = /*#__PURE__*/_createTextVNode("违规重审")
const _hoisted_39 = /*#__PURE__*/_createTextVNode("审核")
const _hoisted_40 = /*#__PURE__*/_createTextVNode("上传")
const _hoisted_41 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_image = _resolveComponent("a-image")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_upload = _resolveComponent("a-upload")!
  const _component_EditorComponent = _resolveComponent("EditorComponent")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_card, { title: "好物圈推荐" }, {
      extra: _withCtx(() => [
        _createVNode(_component_a_button, {
          type: "primary",
          onClick: $setup.addApply
        }, {
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          layout: "inline",
          model: _ctx.formState
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, { label: "商品名称" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.searches.goods_name,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searches.goods_name) = $event)),
                  placeholder: "商品名称"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "优惠券名称" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.searches.coupon_name,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searches.coupon_name) = $event)),
                  placeholder: "优惠券名称"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_button, {
                  type: "primary",
                  onClick: $setup.onSearch
                }, {
                  default: _withCtx(() => [
                    _hoisted_2
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_button, { onClick: $setup.onReset }, {
                  default: _withCtx(() => [
                    _hoisted_3
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"]),
        _createVNode(_component_a_table, {
          dataSource: _ctx.list,
          columns: $setup.columns,
          bordered: "",
          pagination: $setup.pagination,
          onChange: $setup.handleTableChange,
          style: {"margin-top":"10px"}
        }, {
          bodyCell: _withCtx(({ column, text, record }) => [
            (column.key === 'goods_image')
              ? (_openBlock(), _createBlock(_component_a_image, {
                  key: 0,
                  src:  'http://jjyyimage.ynjjyy.cn/' + record.goods_image,
                  style: {"width":"50px"}
                }, null, 8, ["src"]))
              : _createCommentVNode("", true),
            (column.key === 'copywriting')
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  innerHTML: record.copywriting
                }, null, 8, _hoisted_4))
              : _createCommentVNode("", true),
            (column.key === 'images')
              ? (_openBlock(), _createBlock(_component_a_image, {
                  key: 2,
                  src: record.images,
                  style: {"width":"50px"}
                }, null, 8, ["src"]))
              : _createCommentVNode("", true),
            (column.key === 'background_image')
              ? (_openBlock(), _createBlock(_component_a_image, {
                  key: 3,
                  src: record.background_image,
                  style: {"width":"50px"}
                }, null, 8, ["src"]))
              : _createCommentVNode("", true),
            (column.key === 'status')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                  (record.status == 0)
                    ? (_openBlock(), _createBlock(_component_a_tag, {
                        key: 0,
                        color: "#f50"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_5
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (record.status == 1)
                    ? (_openBlock(), _createBlock(_component_a_tag, {
                        key: 1,
                        color: "#2db7f5"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_6
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true),
            (column.key === 'action')
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createVNode(_component_a_button, {
                    size: "small",
                    onClick: ($event: any) => ($setup.edit(record))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_8
                    ]),
                    _: 2
                  }, 1032, ["onClick"]),
                  _createVNode(_component_a_popconfirm, {
                    title: "设置状态?",
                    onConfirm: ($event: any) => ($setup.onStatus(record,1)),
                    onCancel: ($event: any) => ($setup.onStatus(record,0)),
                    "ok-text": "显示",
                    "cancel-text": "不显示"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, {
                        size: "small",
                        style: {"margin":"5px"}
                      }, {
                        default: _withCtx(() => [
                          _hoisted_9
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1032, ["onConfirm", "onCancel"]),
                  _createVNode(_component_a_popconfirm, {
                    title: "是否删除该内容?",
                    onConfirm: ($event: any) => ($setup.onDel(record))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, {
                        size: "small",
                        style: {"margin":"5px"}
                      }, {
                        default: _withCtx(() => [
                          _hoisted_10
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1032, ["onConfirm"])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["dataSource", "columns", "pagination", "onChange"])
      ]),
      _: 1
    }),
    _createVNode(_component_a_modal, {
      visible: _ctx.visible,
      "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.visible) = $event)),
      title: _ctx.title,
      width: "60%",
      onOk: _cache[7] || (_cache[7] = ($event: any) => ($setup.onSubmit('formRef'))),
      "ok-text": _ctx.oKtext
    }, {
      default: _withCtx(() => [
        (_ctx.showtype == 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createVNode(_component_a_input, {
                placeholder: "商品名称",
                style: {"width":"200px"},
                value: _ctx.name,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.name) = $event))
              }, null, 8, ["value"]),
              _createVNode(_component_a_button, {
                type: "primary",
                onClick: $setup.onSearch2,
                style: {"margin-left":"10px"}
              }, {
                default: _withCtx(() => [
                  _hoisted_12
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_a_button, {
                onClick: $setup.onReset2,
                style: {"margin-left":"10px"}
              }, {
                default: _withCtx(() => [
                  _hoisted_13
                ]),
                _: 1
              }, 8, ["onClick"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.showtype == 1)
          ? (_openBlock(), _createBlock(_component_a_table, {
              key: 1,
              rowKey: record=>record.id,
              dataSource: _ctx.goolList,
              "row-selection": { type: 'radio', onChange: $setup.onSelect , selectedRowKeys: _ctx.multipleSelection,},
              columns: $setup.columns2,
              loading: _ctx.loading,
              bordered: "",
              pagination: $setup.pagination2,
              onChange: $setup.handleTableChange2,
              style: {"margin-top":"10px"}
            }, {
              bodyCell: _withCtx(({ column, text, record }) => [
                (column.key === 'shop')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("img", {
                        src: record.shop_logo,
                        style: {"width":"50px","height":"50px","position":"absolute","margin-top":"10px"}
                      }, null, 8, _hoisted_14),
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("div", null, [
                          _hoisted_16,
                          _createElementVNode("span", null, _toDisplayString(record.shop_name), 1)
                        ]),
                        _createElementVNode("div", null, [
                          _hoisted_17,
                          _createElementVNode("span", null, _toDisplayString(record.shop_id), 1)
                        ]),
                        _createVNode(_component_a_tag, { color: "blue" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(record.shop_type_desc), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ])
                    ], 64))
                  : _createCommentVNode("", true),
                (column.key === 'goods')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createElementVNode("img", {
                        src: record.image,
                        style: {"width":"50px","height":"50px","margin-top":"-25px","position":"absolute"}
                      }, null, 8, _hoisted_18),
                      _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("div", _hoisted_20, [
                          _hoisted_21,
                          _createElementVNode("span", null, _toDisplayString(record.name), 1)
                        ]),
                        _createElementVNode("div", _hoisted_22, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(record.cate_name_address, (item, index) => {
                            return (_openBlock(), _createElementBlock("span", { key: index }, [
                              (index>10)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_23, " > "))
                                : _createCommentVNode("", true),
                              _createTextVNode(" " + _toDisplayString(item), 1)
                            ]))
                          }), 128))
                        ])
                      ])
                    ], 64))
                  : _createCommentVNode("", true),
                (column.key === 'copywriting')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString(record.copywriting), 1))
                  : _createCommentVNode("", true),
                (column.key === 'sale')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                      _createElementVNode("div", null, [
                        _hoisted_26,
                        _createElementVNode("span", null, _toDisplayString(record.min_price) + "-" + _toDisplayString(record.max_price), 1)
                      ]),
                      _createElementVNode("div", null, [
                        _hoisted_27,
                        _createElementVNode("span", null, _toDisplayString(record.sales_actual), 1)
                      ]),
                      _createElementVNode("div", null, [
                        _hoisted_28,
                        _createElementVNode("span", null, _toDisplayString(record.stock), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (column.key === 'update_time')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                      _createElementVNode("div", null, [
                        _hoisted_30,
                        _createElementVNode("span", null, _toDisplayString(record.create_time), 1)
                      ]),
                      _createElementVNode("div", null, [
                        _hoisted_31,
                        _createElementVNode("span", null, _toDisplayString(record.update_time), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (column.key === 'tags')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                      _createElementVNode("div", null, [
                        _hoisted_33,
                        _createElementVNode("span", null, [
                          _createVNode(_component_a_tag, { color: "blue" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(record.audit_status == 1 ? '审核通过' : '未通过'), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ])
                      ]),
                      _createElementVNode("div", null, [
                        _hoisted_34,
                        _createElementVNode("span", null, _toDisplayString(record.audit_remark), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (column.key === 'action')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                      _createVNode(_component_a_button, { size: "small" }, {
                        default: _withCtx(() => [
                          _hoisted_36
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_button, {
                        size: "small",
                        style: {"margin-left":"10px"}
                      }, {
                        default: _withCtx(() => [
                          _hoisted_37
                        ]),
                        _: 1
                      }),
                      (_ctx.searches.type == 1)
                        ? (_openBlock(), _createBlock(_component_a_button, {
                            key: 0,
                            size: "small",
                            style: {"margin-left":"10px"},
                            onClick: ($event: any) => (_ctx.goodsReAudit(record))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_38
                            ]),
                            _: 2
                          }, 1032, ["onClick"]))
                        : _createCommentVNode("", true),
                      (_ctx.searches.type == 4)
                        ? (_openBlock(), _createBlock(_component_a_button, {
                            key: 1,
                            size: "small",
                            style: {"margin-left":"10px"}
                          }, {
                            default: _withCtx(() => [
                              _hoisted_39
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["rowKey", "dataSource", "row-selection", "columns", "loading", "pagination", "onChange"]))
          : _createCommentVNode("", true),
        (_ctx.showtype == 2)
          ? (_openBlock(), _createBlock(_component_a_form, {
              key: 2,
              ref: "formRef",
              rules: $setup.rules,
              model: _ctx.formState,
              name: "basic",
              "label-col": { span: 2 } ,
              "wrapper-col": { span: 20 },
              autocomplete: "off"
            }, {
              default: _withCtx(() => [
                (_ctx.shop_name != '' )
                  ? (_openBlock(), _createBlock(_component_a_form_item, {
                      key: 0,
                      label: "商品名称"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", null, _toDisplayString(_ctx.shop_name), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_a_form_item, {
                  label: "宣传图",
                  name: "images"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_upload, {
                      name: "file",
                      "file-list": _ctx.fileList,
                      "onUpdate:file-list": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.fileList) = $event)),
                      class: "avatar-uploader",
                      "show-upload-list": false,
                      headers: $setup.uploadHeaders,
                      action: $setup.uploadAction,
                      data: $setup.uploadFormData,
                      onChange: $setup.handleChange
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", null, [
                          _createVNode(_component_a_button, null, {
                            default: _withCtx(() => [
                              _hoisted_40
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _: 1
                    }, 8, ["file-list", "headers", "action", "data", "onChange"])
                  ]),
                  _: 1
                }),
                (_ctx.formState.images!== '' )
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 1,
                      src: _ctx.formState.images,
                      style: {"width":"50px","margin-top":"-20px","margin-left":"120px","margin-bottom":"20px"}
                    }, null, 8, _hoisted_41))
                  : _createCommentVNode("", true),
                _createVNode(_component_a_form_item, {
                  label: "文案",
                  name: "copywriting"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createBlock(_component_EditorComponent, {
                      ref: "editorComponentRef",
                      key: _ctx.protocolType,
                      content: _ctx.formState.copywriting,
                      height: 400
                    }, null, 8, ["content"]))
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_form_item, {
                  label: "专属优惠券",
                  name: "coupon_id"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select, {
                      ref: "select",
                      value: _ctx.formState.coupon_id,
                      "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formState.coupon_id) = $event)),
                      placeholder: "请选择专属优惠券",
                      onPopupScroll: $setup.handlePopupScroll
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.couponList, (item, index) => {
                          return (_openBlock(), _createBlock(_component_a_select_option, {
                            value: item.id
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.name), 1)
                            ]),
                            _: 2
                          }, 1032, ["value"]))
                        }), 256))
                      ]),
                      _: 1
                    }, 8, ["value", "onPopupScroll"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_form_item, {
                  label: "排序",
                  name: "sort"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input, {
                      value: _ctx.formState.sort,
                      "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formState.sort) = $event)),
                      placeholder: "请输入排序"
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["rules", "model"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["visible", "title", "ok-text"])
  ]))
}